<template>
  <div class="faq-root py-16">
    <div class="max-w-4xl mx-auto">
      <div
        v-for="(faqSection, index) in faqsTemplate"
        :key="`faq-section-${index}`"
        class="faq-sections mb-18"
      >
        <FormattedHeader :header="faqSection.type" />
        <FaqGrid :items="faqSection.qnas" />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, useMeta } from '@nuxtjs/composition-api';
import FormattedHeader from '@/components/FormattedHeader.vue';
import FaqGrid from '@/modules/InformationPages/Faq/components/FaqGrid.vue';
import { faqs } from '@/modules/InformationPages/Faq/mocks/index';
import useGlobalSettings from '@/hooks/useGlobalSettings';

export default defineComponent({
  name: 'FaqRoot',
  components: { FaqGrid, FormattedHeader },
  setup() {
    const header = `Frequently Asked Questions`;
    const subheader = `These are some of the questions that we get asked most about HR compliance, and how Bambee works to help businesses. If you have a questions you want answered, contact us anytime by phone, email, or chat.`;
    const { setHeader } = useGlobalSettings();

    setHeader({
      header,
      subheader,
      heroImage: `assets/information/faq/faq-hero-v2.jpg`,
      metaTitle: header,
      registration: false,
      noHero: false,
    });

    useMeta(() => ({ title: header }));

    return {
      faqsTemplate: faqs.filter((f) => !!f.type),
    };
  },
  head() {},
});
</script>
